
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SOCIAL_LINK_FACEBOOK, SOCIAL_LINK_INSTAGRAM, SOCIAL_LINK_LINKEDIN, SOCIAL_LINK_TIKTOK, SOCIAL_LINK_YOUTUBE } from '../../shared/constants';

@Component({
    selector: 'app-social',
    imports: [],
    templateUrl: './social.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './social.component.scss'
})
export class SocialComponent {
  socialPlatforms = [
    {
      name: 'LinkedIn',
      link: SOCIAL_LINK_LINKEDIN,
      icon: 'images/svg/linkedin-icon.svg',
      color: '#FFFFFF'
    },
    {
      name: 'TikTok',
      link: SOCIAL_LINK_TIKTOK,
      icon: 'images/svg/tiktok-icon.svg',
      color: '#FFFFFF'
    },
    {
      name: 'YouTube',
      link: SOCIAL_LINK_YOUTUBE,
      icon: 'images/svg/tiktok-icon.svg',
      color: '#DD0000'
    },
    {
      name: 'Facebook',
      link: SOCIAL_LINK_FACEBOOK,
      icon: 'images/svg/facebook-icon.svg',
      color: '#FFFFFF'
    },
    {
      name: 'Instagram',
      link: SOCIAL_LINK_INSTAGRAM,
      icon: 'images/svg/instagram-icon.svg',
      color: '#FFFFFF'
    },
  ];
}
